export enum ApelacionParcialEstados {
	cesar_suspencion = 'S',
	multa_sin_efecto = 'M',
}
